const D2Sources: {
  [key: string]: {
    itemHashes?: number[];
    sourceHashes?: number[];
    aliases?: string[];
    enteredDCV?: number;
  };
} = {
  '30th': {
    sourceHashes: [
      443340273, // Source: Xûr's Treasure Hoard in Eternity
      675740011, // Source: "Grasp of Avarice" Dungeon
      1102533392, // Source: Xûr (Eternity)
      1394793197, // Source: "Magnum Opus" Quest
      2763252588, // Source: "And Out Fly the Wolves" Quest
    ],
  },
  adventure: {
    sourceHashes: [
      194661944, // Source: Adventure "Siren Song" on Saturn's Moon, Titan
      482012099, // Source: Adventure "Thief of Thieves" on Saturn's Moon, Titan
      636474187, // Source: Adventure "Deathless" on Saturn's Moon, Titan
      783399508, // Source: Adventure "Supply and Demand" in the European Dead Zone
      790433146, // Source: Adventure "Dark Alliance" in the European Dead Zone
      1067250718, // Source: Adventure "Arecibo" on Io
      1186140085, // Source: Adventure "Unbreakable" on Nessus
      1289998337, // Source: Adventure "Hack the Planet" on Nessus
      1527887247, // Source: Adventure "Red Legion, Black Oil" in the European Dead Zone
      1736997121, // Source: Adventure "Stop and Go" in the European Dead Zone
      1861838843, // Source: Adventure "A Frame Job" in the European Dead Zone
      2040548068, // Source: Adventure "Release" on Nessus
      2096915131, // Source: Adventure "Poor Reception" in the European Dead Zone
      2345202459, // Source: Adventure "Invitation from the Emperor" on Nessus
      2392127416, // Source: Adventure "Cliffhanger" on Io
      2553369674, // Source: Adventure "Exodus Siege" on Nessus
      3427537854, // Source: Adventure "Road Rage" on Io
      3754173885, // Source: Adventure "Getting Your Hands Dirty" in the European Dead Zone
      4214471686, // Source: Adventure "Unsafe at Any Speed" in the European Dead Zone
    ],
    enteredDCV: 20,
  },
  avalon: {
    sourceHashes: [
      709680645, // Source: "Truly Satisfactory" Triumph
      1476475066, // Source: "Firmware Update" Triumph
      1730197643, // Source: //node.ovrd.AVALON// Exotic Quest
    ],
    enteredDCV: 24,
  },
  battlegrounds: {
    itemHashes: [
      1291040554, // Brass Attacks
      2121785039, // Brass Attacks
      3075224551, // Threaded Needle
      3109297883, // Brass Attacks
    ],
    sourceHashes: [
      3391325445, // Source: Battlegrounds
    ],
    enteredDCV: 24,
  },
  blackarmory: {
    itemHashes: [
      417164956, // Jötunn
      2490460292, // Stryker's Sure-Hand
      2531614757, // Tatara Gaze
      3211806999, // Izanagi's Burden
      3588934839, // Le Monarque
      3650581584, // New Age Black Armory
      3650581585, // Refurbished Black Armory
      3650581586, // Rasmussen Clan
      3650581587, // House of Meyrin
      3650581588, // Satou Tribe
      3650581589, // Bergusian Night
      3961462214, // Kindled Orchid
    ],
    sourceHashes: [
      266896577, // Source: Solve the Norse glyph puzzle.
      439994003, // Source: Complete the "Master Smith" Triumph.
      925197669, // Source: Complete a Bergusia Forge ignition.
      948753311, // Source: Found by completing Volundr Forge ignitions.
      1286332045, // Source: Found by completing Izanami Forge ignitions.
      1457456824, // Source: Complete the "Reunited Siblings" Triumph.
      1465990789, // Source: Solve the Japanese glyph puzzle.
      1596507419, // Source: Complete a Gofannon Forge ignition.
      2062058385, // Source: Crafted in a Black Armory forge.
      2384327872, // Source: Solve the French glyph puzzle.
      2541753910, // Source: Complete the "Master Blaster" Triumph.
      2966694626, // Source: Found by solving the mysteries behind the Black Armory's founding families.
      3047033583, // Source: Returned the Obsidian Accelerator.
      3257722699, // Source: Complete the "Clean Up on Aisle Five" Triumph.
      3390164851, // Source: Found by turning in Black Armory bounties.
      3764925750, // Source: Complete an Izanami Forge ignition.
      4101102010, // Source: Found by completing Bergusia Forge ignitions.
      4247521481, // Source: Complete the "Beautiful but Deadly" Triumph.
      4290227252, // Source: Complete a Volundr Forge ignition.
    ],
    aliases: ['ada'],
    enteredDCV: 20,
  },
  brave: {
    itemHashes: [
      52683113, // Blast Furnace
      205225492, // Hung Jury SR4
      211732170, // Hammerhead
      243425374, // Falling Guillotine
      381446446, // Elsie's Rifle
      570866107, // Succession
      697459665, // Hung Jury SR4
      1346714574, // Hammerhead
      2033531688, // Luna's Howl
      2033531689, // Midnight Coup
      2228325504, // Edge Transit
      2480074702, // Forbearance
      2480871539, // Falling Guillotine
      2499720827, // Midnight Coup
      2533990645, // Blast Furnace
      2731922624, // Succession
      3098328572, // The Recluse
      3257283337, // The Recluse
      3736001860, // Forbearance
      3736001861, // The Mountaintop
      3736001863, // Edge Transit
      3757612024, // Luna's Howl
      3851176026, // Elsie's Rifle
      4043921923, // The Mountaintop
    ],
    sourceHashes: [
      2952071500, // Source: Into the Light
    ],
  },
  calus: {
    itemHashes: [
      947448544, // Shadow of Earth Shell
      1661191192, // The Tribute Hall
      1661191193, // Crown of Sorrow
      1661191194, // A Hall of Delights
      1661191195, // The Imperial Menagerie
      2027598066, // Imperial Opulence
      2027598067, // Imperial Dress
      2816212794, // Bad Juju
      3176509806, // Árma Mákhēs
      3580904580, // Legend of Acrius
      3841416152, // Golden Empire
      3841416153, // Goldleaf
      3841416154, // Shadow Gilt
      3841416155, // Cinderchar
      3875444086, // The Emperor's Chosen
    ],
    enteredDCV: 20,
    sourceHashes: [
      1675483099, // Source: Leviathan, Spire of Stars raid lair.
      2399751101, // Acquired from the raid "Crown of Sorrow."
      2511152325, // Acquired from the Menagerie aboard the Leviathan.
      2653618435, // Source: Leviathan raid.
      2765304727, // Source: Leviathan raid on Prestige difficulty.
      2812190367, // Source: Leviathan, Spire of Stars raid lair on Prestige difficulty.
      2937902448, // Source: Leviathan, Eater of Worlds raid lair.
      3147603678, // Acquired from the raid "Crown of Sorrow."
      4009509410, // Source: Complete challenges in the Leviathan raid.
      4066007318, // Source: Leviathan, Eater of Worlds raid lair on Prestige difficulty.
    ],
  },
  campaign: {
    sourceHashes: [
      13912404, // Source: Unlock Your Arc Subclass
      100617404, // Requires Titan Class
      286427063, // Source: Fallen Empire Campaign
      409652252, // Source: The Witch Queen Campaign
      431243768, // Source: The Edge of Fate Campaign
      460742691, // Requires Guardian Rank 6: Masterwork Weapons
      569214265, // Source: Red War Campaign
      633667627, // Requires Tier 4 or 5 Weapon
      677167936, // Source: Complete the campaign as a Warlock.
      712662541, // Requires Season 27 Tier 5 Weapon
      736336644, // Source: "A Spark of Hope" Quest
      901482731, // Source: Lightfall Campaign
      918840100, // Source: Shadowkeep Campaign
      923708784, // Requires Guardian Rank 7: Threats and Surges
      958460845, // Source: The Final Shape Campaign
      1076222895, // Source: Defeat bosses in Flashpoints.
      1103518848, // Source: Earned over the course of the Warmind campaign.
      1118966764, // Source: Dismantle an item with this shader applied to it.
      1281387702, // Source: Unlock Your Void Subclass
      1701477406, // Source: Flashpoint milestones; Legendary engrams.
      2242939082, // Requires Hunter Class
      2278847330, // Requires Guardian Rank 3
      2308290458, // Requires 1,000 Warlock Kills
      2552784968, // Requires Guardian Rank 2
      2744321951, // Source: Complete a heroic Public Event.
      2892963218, // Source: Earned while leveling.
      2895784523, // Source: Pledge to all factions on a single character.
      2929562373, // Source: Unlock Your Solar Subclass
      2988465950, // Source: Planetary faction chests.
      3099553329, // Source: Complete the campaign as a Titan.
      3126774631, // Requires 1,000 Hunter Kills
      3174947771, // Requires Guardian Rank 6: Vendor Challenges
      3431853656, // Achieved a Grimoire score of over 5000 in Destiny.
      3532642391, // Source: Forsaken Campaign
      3704442923, // Source: Curse of Osiris Campaign
      3936473457, // Requires Warlock Class
      4008954452, // Requires Shaped or Enhanced Weapon
      4288102251, // Requires 1,000 Titan Kills
      4290499613, // Source: Complete the campaign as a Hunter.
    ],
  },
  cayde6: {
    sourceHashes: [
      2206233229, // Source: Follow treasure maps.
    ],
    enteredDCV: 20,
  },
  charity: {
    itemHashes: [
      40494562, // Caped Cruiser
      171635528, // Hearts of Gold
      171635529, // Principled Porphyry
      171635530, // Argent Champion
      371705660, // Unconditional Love
      765122182, // Tenderhearted Shell
      826128643, // Small Luminance
      902219633, // Bridge of Magpies
      1047542010, // On Your Sleeve
      1047542011, // Heart Felt
      1059396448, // Tenth Muse
      1059396449, // Boundless
      1059396450, // Steadfast Column
      1059396451, // True Self
      1059396454, // Indivisible
      1061507881, // Altair Runner
      1165452712, // Cosmic Tune
      1257250409, // Seventh Sail
      1283654212, // Gilded Shell
      2068483326, // Phosphor Gladiator
      2268540161, // Warm Munificence
      2609270227, // Arena Shell
      2635366068, // Buoyant Shell
      2650448800, // Love Note Shell
      2650448801, // Heart's Oath Shell
      2704911691, // Lovestruck
      2749628923, // Disciple's Shell
      2764545753, // Empathic Shell
      2778157412, // Sweetheart Shell
      2811138603, // Altrux Pura Mk1
      3154194046, // Kilted Out
      3159276286, // Cosmic Arcade
      3229426560, // Laser Tag Brag
      3596008431, // Pale Blue Dot
      3919847952, // Circadian Guard
      4163975820, // Lubraean Luxury
      4182403848, // Prismatic Expanse
      4201060647, // Offset
      4222561358, // Light Hearted
      4253857367, // Heartful Shell
    ],
    sourceHashes: [
      2985242208, // Source: Earned from a charity promotion.
    ],
  },
  compass: {
    sourceHashes: [
      164083100, // Source: Display of Supremacy, Weekly Challenge
      3100439379, // Source: Mission "Exorcism"
    ],
    enteredDCV: 20,
  },
  conquest: {
    sourceHashes: [
      1331532890, // Source: Seasonal Conquest Triumph "Ultimate Victory"
    ],
  },
  contact: {
    sourceHashes: [
      2039343154, // Source: Contact Public Event
    ],
    enteredDCV: 20,
  },
  cosmodrome: {
    sourceHashes: [
      2908547701, // Cosmodrome
    ],
  },
  crotasend: {
    sourceHashes: [
      1897187034, // Source: "Crota's End" Raid
    ],
    aliases: ['crota'],
  },
  crownofsorrow: {
    itemHashes: [
      947448544, // Shadow of Earth Shell
      1661191193, // Crown of Sorrow
      2027598066, // Imperial Opulence
      2027598067, // Imperial Dress
    ],
    sourceHashes: [
      2399751101, // Acquired from the raid "Crown of Sorrow."
      3147603678, // Acquired from the raid "Crown of Sorrow."
    ],
    aliases: ['cos'],
    enteredDCV: 20,
  },
  crucible: {
    itemHashes: [
      2307365, // The Inquisitor (Adept)
      51129316, // The Inquisitor
      161675590, // Whistler's Whim (Adept)
      217940910, // Wild Anthem Vest
      225063086, // Wild Anthem Gauntlets
      250597586, // Disaster Corps Gauntlets
      303107619, // Tomorrow's Answer (Adept)
      350102826, // Triumphal Anthem Robes
      361848666, // Wild Anthem Grips
      374648029, // Triumphal Anthem Strides
      420604757, // Last Discipline Bond
      438409602, // Disaster Corps Vest
      501345268, // Shayura's Wrath (Adept)
      517814638, // Disaster Corps Grasps
      536035447, // Wild Anthem Cloak
      548809020, // Exalted Truth
      571839605, // Triumphal Anthem Gauntlets
      586381823, // Disaster Corps Boots
      627188188, // Eye of Sol
      651836012, // Disaster Corps Greaves
      711889599, // Whistler's Whim (Adept)
      747743636, // Redrix's Estoc
      747743637, // Belisarius-D
      769099721, // Devil in the Details
      825554997, // The Inquisitor (Adept)
      854379020, // Astral Horizon (Adept)
      874623537, // Cataphract GL3 (Adept)
      906840740, // Unwavering Duty
      986920507, // Triumphal Anthem Bond
      1041028434, // Rose
      1064523906, // Triumphal Anthem Mark
      1109145282, // Last Discipline Cloak
      1141586039, // Unexpected Resurgence (Adept)
      1172384181, // Last Discipline Grasps
      1201528146, // Exalted Truth (Adept)
      1230660649, // Victory's Wreath
      1292594730, // The Summoner (Adept)
      1321626661, // Eye of Sol (Adept)
      1334855187, // Wild Anthem Mark
      1401300690, // Eye of Sol
      1459620921, // Last Discipline Plate
      1516542120, // Frozen Orbit
      1574601402, // Whistler's Whim
      1618320532, // Wild Anthem Strides
      1644501332, // Anonymous Autumn
      1644825026, // Wild Anthem Plate
      1661191197, // Disdain for Glitter
      1703017178, // Disaster Corps Bond
      1705843397, // Exalted Truth (Adept)
      1711056134, // Incisor
      1820994983, // The Summoner
      1893967086, // Keen Thistle
      1930651768, // Wild Anthem Cover
      1968410628, // The Prophet
      1973107014, // Igneous Hammer
      1973631360, // Triumphal Anthem Boots
      2022294213, // Shayura's Wrath
      2025110456, // Last Discipline Vestment
      2039591531, // Wild Anthem Mask
      2059255495, // Eye of Sol (Adept)
      2134373071, // Wild Anthem Robes
      2147961687, // Triumphal Anthem Greaves
      2150012406, // Joxer's Longsword
      2185327324, // The Inquisitor
      2278464039, // Wild Anthem Helm
      2297554989, // Riptide
      2300143112, // Yesterday's Question
      2314610827, // Igneous Hammer (Adept)
      2324823787, // Triumphal Anthem Plate
      2330860573, // The Inquisitor (Adept)
      2378785953, // Yesterday's Question (Adept)
      2394455241, // Wild Anthem Gloves
      2403923088, // Last Discipline Gloves
      2414564781, // Punctuation Marks
      2414602118, // Triumphal Anthem Gloves
      2420153991, // Made Shaxx Proud
      2421180981, // Incisor (Adept)
      2480734911, // Triumphal Anthem Cover
      2557300061, // Disaster Corps Gloves
      2571112423, // Disaster Corps Mask
      2579239008, // Out of Bounds
      2579239009, // Unending Tempest
      2588739576, // Crucible Solemnity
      2588739578, // Crucible Legacy
      2588739579, // Crucible Metallic
      2600892776, // Disaster Corps Strides
      2629942414, // Last Discipline Helm
      2632846356, // Rain of Ashes
      2653171212, // The Inquisitor
      2653171213, // Astral Horizon
      2686397083, // Wild Anthem Boots
      2727863512, // Triumphal Anthem Cloak
      2732598696, // Wild Anthem Greaves
      2738601016, // Cataphract GL3
      2748506263, // Last Discipline Strides
      2752429099, // Last Discipline Vest
      2757996223, // Disaster Corps Mark
      2759251821, // Unwavering Duty (Adept)
      2762558442, // Last Discipline Boots
      2773786868, // Last Discipline Mark
      2804194275, // Disaster Corps Vestment
      2839600459, // Incisor (Adept)
      2932138009, // Last Discipline Hood
      2992986244, // Disaster Corps Hood
      3000956609, // Last Discipline Greaves
      3001205424, // Ecliptic Distaff
      3009199534, // Tomorrow's Answer
      3019024381, // The Prophet (Adept)
      3102421004, // Exalted Truth
      3153400267, // Triumphal Anthem Grips
      3165143747, // Whistler's Whim
      3193598749, // The Immortal (Adept)
      3332125295, // Aisha's Care (Adept)
      3364253967, // Last Perdition
      3408026115, // Disaster Corps Helm
      3428369046, // Disaster Corps Plate
      3436626079, // Exalted Truth
      3444632029, // Unwavering Duty (Adept)
      3470352892, // Triumphal Anthem Helm
      3503560035, // Keen Thistle (Adept)
      3624844116, // Unwavering Duty
      3688176697, // Retrofuturist
      3805886046, // Wild Anthem Bond
      3855332578, // Triumphal Anthem Mask
      3902351469, // The Keening
      3920882229, // Exalted Truth (Adept)
      3926987546, // Deadlock
      3928440584, // Crucible Carmine
      3928440585, // Crucible Redjack
      3957372883, // Disaster Corps Cloak
      3969379530, // Aisha's Care
      4005780578, // Unexpected Resurgence
      4039572196, // The Immortal
      4059111041, // Better Devils
      4060882456, // Rubicund Wrap (Ornament)
      4071845509, // Triumphal Anthem Vest
      4079706495, // Last Discipline Gauntlets
      4112577340, // Last Discipline Mask
      4176824345, // Randy's Throwing Knife
      4248997900, // Incisor
      4257236930, // Mercurial Overreach
    ],
    sourceHashes: [
      164083100, // Source: Display of Supremacy, Weekly Challenge
      454115234, // Source: Associated Crucible Quest
      598662729, // Source: Reach Glory Rank "Legend" in the Crucible.
      705363737, // Source: Heavy Metal: Supremacy
      745186842, // Source: Associated Crucible Quest
      897576623, // Source: Complete Crucible matches and earn rank-up packages from Lord Shaxx.
      929025440, // Acquired by competing in the Crucible during the Prismatic Inferno.
      1217831333, // Source: Associated Crucible Quest
      1223492644, // Source: Complete the "Reconnaissance by Fire" quest.
      1465057711, // Source: Standard Ritual Playlist. (Vanguard Ops, Crucible, Gambit)
      1494513645, // Source: Glory Matches in Crucible
      2055470113, // Source: Chance to acquire when completing Crucible Survival matches after reaching Glory Rank "Mythic."
      2537301256, // Source: Glory Rank of "Fabled" in Crucible
      2558941813, // Source: Place Silver III Division or Higher in Ranked Crucible Playlists
      2602565384, // Source: Win competitive matches while at Ascendant 0 Rank.
      2622122683, // Source: Lord Shaxx Rank Up Reputation
      2641169841, // Source: Purchase from Lord Shaxx
      2658055900, // Source: Complete the "Season 8: Battle Drills" quest.
      2669524419, // Source: Crucible
      2821852478, // Source: Complete this weapon's associated Crucible quest.
      2915991372, // Source: Crucible
      3020288414, // Source: Crucible
      3226099405, // Source: Crucible Seasonal Ritual Rank Reward
      3299964501, // Source: Earn Ranks in Vanguard, Crucible, or Gambit Playlists
      3348906688, // Source: Ranks in Vanguard Strikes, Crucible, or Gambit
      3466789677, // Source: Place Ascendant III Division or Higher in Ranked Crucible Playlists
      3656787928, // Source: Crucible Salvager's Salvo Armament
      4094465789, // Source: Win 77 Matches in the competitive playlist.
    ],
    aliases: ['shaxx'],
  },
  deepstonecrypt: {
    sourceHashes: [
      866530798, // Source: "Not a Scratch" Triumph
      1405897559, // Source: "Deep Stone Crypt" Raid
      1692165595, // Source: "Rock Bottom" Triumph
    ],
    aliases: ['dsc'],
  },
  deluxe: {
    sourceHashes: [
      639650067, // Source: Limited Edition of Destiny 2.
      1358645302, // Source: Unlocked by a special offer.
      1412777465, // Source: Forsaken Refer-a-Friend
      1743434737, // Source: Destiny 2 "Forsaken" preorder bonus gift.
      1866448829, // Source: Deluxe Edition Bonus
      2968206374, // Source: Earned as a Deluxe Edition bonus.
      3173463761, // Source: Pre-order Bonus
      3212282221, // Source: Forsaken Annual Pass
      3672287903, // Source: The Witch Queen Digital Deluxe Edition
      4069355515, // Source: Handed out at US events in 2019.
      4166998204, // Source: Earned as a pre-order bonus.
    ],
    aliases: ['limited'],
  },
  desertperpetual: {
    sourceHashes: [
      596084342, // Source: "The Desert Perpetual" Raid
      2127551856, // Source: "The Desert Perpetual" Epic Raid
    ],
  },
  do: {
    sourceHashes: [
      146504277, // Source: Earn rank-up packages from Arach Jalaal.
    ],
    enteredDCV: 20,
  },
  dreaming: {
    itemHashes: [
      185321779, // Ennead
      268357178, // Twilight Oath
      1291270049, // Abide the Return
      1727550459, // Waking Vigil
      1738552769, // Sleepless
      3218302023, // Vouchsafe
      3352019292, // Secret Victories
      3442151842, // Retold Tale
    ],
    sourceHashes: [
      2180169027, // The Dreaming City
      2559145507, // Source: Complete activities in the Dreaming City.
      3874934421, // Source: Complete Nightfall strike "The Corrupted."
    ],
  },
  duality: {
    itemHashes: [
      1780464822, // New Purpose
      2026087437, // Lingering Dread
      3000847393, // Unforgiven
      3652506829, // Stormchaser
    ],
    sourceHashes: [
      1282207663, // Source: Dungeon "Duality"
    ],
  },
  dungeon: {
    sourceHashes: [
      506073192, // Source: "Prophecy" Dungeon
      613435025, // Source: "Warlord's Ruin" Dungeon
      675740011, // Source: "Grasp of Avarice" Dungeon
      877404349, // Source: Rite of the Nine
      1282207663, // Source: Dungeon "Duality"
      1597738585, // Source: "Spire of the Watcher" Dungeon
      1745960977, // Source: "Pit of Heresy" Dungeon
      2463956052, // Source: Vesper's Host
      2607970476, // Source: Sundered Doctrine
      3247513834, // Source: Equilibrium
      3288974535, // Source: "Ghosts of the Deep" Dungeon
      4051531374, // Complete the "Shattered Throne" dungeon.
    ],
    itemHashes: [
      8293111, // Long Arm
      14929251, // Long Arm
      93061497, // VS Gravitic Arrest
      185321778, // The Eternal Return
      189194532, // No Survivors (Adept)
      233402416, // New Pacific Epitaph (Adept)
      291447487, // Cold Comfort
      435821040, // Darkest Before
      435821041, // Relentless
      487205709, // Terminus Horizon
      492673102, // New Pacific Epitaph
      559523765, // Wilderflight (Adept)
      749483159, // Prosecutor (Adept)
      814876684, // Wish-Ender
      839344841, // Vengeful Whisper
      839786290, // Cold Comfort
      880829467, // Prosecutor
      1013434963, // Adjudicator
      1050582210, // Greasy Luck (Adept)
      1066598837, // Relentless (Adept)
      1125217994, // New Pacific Epitaph
      1157220231, // No Survivors (Adept)
      1206729100, // Wilderflight
      1303313141, // Unsworn
      1460079227, // Liminal Vigil
      1626437786, // A Sudden Death (Adept)
      1685406703, // Greasy Luck
      1757202961, // Greasy Luck
      1762785662, // VS Chill Inhibitor
      1762785663, // VS Velocity Baton
      1773934241, // Judgment
      1780464822, // New Purpose
      1817605554, // Cold Comfort (Adept)
      1827058652, // Relentless (Adept)
      1904170910, // A Sudden Death
      1905934655, // Liminal Vigil (Adept)
      1969802090, // Premonition
      1976481399, // A Sudden Death
      1987644603, // Judgment (Adept)
      2026087437, // Lingering Dread
      2059741649, // New Pacific Epitaph
      2126543269, // Cold Comfort (Adept)
      2129814338, // Prosecutor
      2130249527, // Death Adder
      2210806903, // Terminus Horizon (Adept)
      2226158470, // Unworthy
      2226572694, // Judgment
      2306182339, // Wilderflight
      2477408004, // Wilderflight (Adept)
      2485881870, // Unloved
      2575844666, // Liminal Vigil
      2730671571, // Terminus Horizon
      2760833884, // Cold Comfort
      2764074355, // A Sudden Death (Adept)
      2806569825, // Naeem's Lance
      2844014413, // Pallas Galliot
      2934305134, // Greasy Luck
      2969415423, // Judgment
      2982006965, // Wilderflight
      3000847393, // Unforgiven
      3138208275, // Liminal Vigil
      3185151619, // New Pacific Epitaph (Adept)
      3210739171, // Greasy Luck (Adept)
      3262192268, // No Survivors
      3329218848, // Judgment (Adept)
      3360937899, // Unvoiced
      3381450498, // Indebted Kindness
      3421639790, // Liminal Vigil (Adept)
      3483591058, // Prosecutor
      3490736392, // Seventh Seraph Officer Revolver
      3652506829, // Stormchaser
      3668817296, // Dragoncult Sickle
      3681280908, // Relentless
      3692140710, // Long Arm (Adept)
      3733988413, // Relentless
      3984556130, // Terminus Horizon
      4025177550, // Prosecutor (Adept)
      4059111040, // Survivor's Epitaph
      4097972038, // A Sudden Death
      4193602194, // No Survivors
      4228149269, // No Survivors
      4232480042, // VS Pyroelectric Propellant
      4239378215, // Long Arm (Adept)
      4249949938, // Long Arm
      4267192886, // Terminus Horizon (Adept)
    ],
  },
  echoes: {
    itemHashes: [
      3156551030, // Patron of Lost Causes
      4108648762, // Perfect Paradox
    ],
    sourceHashes: [
      536806855, // Source: Episode: Echoes
      2306801178, // Source: Episode: Echoes Activities
      2514060836, // Source: Episode: Echoes Enigma Protocol Activity
      2631398023, // Source: Radiolite Bay Deposits
    ],
  },
  edgeoffate: {
    sourceHashes: [
      431243768, // Source: The Edge of Fate Campaign
      4034415948, // Source: The Edge of Fate Activities
    ],
  },
  edz: {
    sourceHashes: [
      653764762, // European Dead Zone
      783399508, // Source: Adventure "Supply and Demand" in the European Dead Zone
      790433146, // Source: Adventure "Dark Alliance" in the European Dead Zone
      1373723300, // Source: Complete activities and earn rank-up packages in the EDZ.
      1527887247, // Source: Adventure "Red Legion, Black Oil" in the European Dead Zone
      1736997121, // Source: Adventure "Stop and Go" in the European Dead Zone
      1861838843, // Source: Adventure "A Frame Job" in the European Dead Zone
      2096915131, // Source: Adventure "Poor Reception" in the European Dead Zone
      3754173885, // Source: Adventure "Getting Your Hands Dirty" in the European Dead Zone
      4214471686, // Source: Adventure "Unsafe at Any Speed" in the European Dead Zone
      4292996207, // Source: World Quest "Enhance!" in the European Dead Zone.
    ],
  },
  eow: {
    sourceHashes: [
      2937902448, // Source: Leviathan, Eater of Worlds raid lair.
      4066007318, // Source: Leviathan, Eater of Worlds raid lair on Prestige difficulty.
    ],
    enteredDCV: 20,
  },
  ep: {
    sourceHashes: [
      4137108180, // Source: Escalation Protocol on Mars.
    ],
    enteredDCV: 20,
  },
  equilibrium: {
    sourceHashes: [
      3247513834, // Source: Equilibrium
    ],
  },
  europa: {
    itemHashes: [
      642545454, // Thermal Erosion
      856316142, // Coriolis Force
      978122008, // Subzero Salvo
      1529367715, // Bonechiller
      2662459958, // High Albedo
      4236134153, // Hailing Confusion
    ],
    sourceHashes: [
      286427063, // Source: Fallen Empire Campaign
      1148859274, // Source: Exploring Europa
      1492981395, // Source: "The Stasis Prototype" Quest
      2171520631, // Source: "Lost Lament" Exotic Quest
      3125456997, // Source: Europan Tour
      3965815470, // Source: Higher Difficulty Empire Hunts
      4137963719, // Europa
    ],
  },
  events: {
    itemHashes: [
      425681240, // Acosmic
      495940989, // Avalanche
      601948197, // Zephyr
      689294985, // Jurassic Green
      1123433952, // Stay Frosty
      1183116657, // Glacioclasm
      1280894514, // Mechabre
      1845372864, // Albedo Wing
      1845978721, // Avalanche
      2477980485, // Mechabre
      2603335652, // Jurassic Green
      2812100428, // Stay Frosty
      2814093983, // Cold Front
      2869466318, // BrayTech Werewolf
      2873681799, // Zephyr
      3003492238, // Zephyr
      3240434620, // Something New
      3400256755, // Zephyr
      3558681245, // BrayTech Werewolf
      3559361670, // The Title
      3573686365, // Glacioclasm
    ],
    sourceHashes: [
      32323943, // Source: Moments of Triumph
      151416041, // Source: Solstice
      464727567, // Source: Dawning 2021
      547767158, // Source: Dawning 2018
      611838069, // Source: Guardian Games
      629617846, // Source: Dawning 2020
      641018908, // Source: Solstice 2018
      772619302, // Completed all 8 Moments of Triumph in Destiny's second year.
      894030814, // Source: Heavy Metal Event
      923678151, // Source: Upgraded Event Card Reward
      1054169368, // Source: Festival of the Lost 2021
      1225476079, // Source: Moments of Triumph 2022
      1232863328, // Source: Moments of Triumph 2024
      1360005982, // Completed a Moment of Triumph in Destiny's second year.
      1397119901, // Completed a Moment of Triumph in Destiny's first year.
      1416471099, // Source: Moments of Triumph 2023
      1462687159, // Reached level 5 in the Ages of Triumph record book.
      1505938361, // Source: Call to Arms Event
      1568732528, // Source: Guardian Games 2024
      1666677522, // Source: Solstice
      1677921161, // Source: Festival of the Lost 2018.
      1919933822, // Source: Festival of the Lost 2020
      1953779156, // Source: Events
      2006303146, // Source: Guardian Games 2022
      2011810450, // Source: Season 13 Guardian Games
      2045032171, // Source: Arms Week Event
      2050870152, // Source: Solstice
      2187511136, // Source: Earned during the seasonal Revelry event.
      2364515524, // Source: Dawning 2022
      2473294025, // Source: Guardian Games 2023
      2502262376, // Source: Earned during the seasonal Crimson Days event.
      2797674516, // Source: Moments of Triumph 2021
      3092212681, // Source: Dawning 2019
      3095773956, // Source: Guardian Games 2025
      3112857249, // Completed all 10 Moments of Triumph in Destiny's first year.
      3190938946, // Source: Festival of the Lost 2019
      3388021959, // Source: Guardian Games
      3482766024, // Source: Festival of the Lost 2024
      3693722471, // Source: Festival of the Lost 2020
      3724111213, // Source: Solstice 2019
      3736521079, // Reached level 1 in the Ages of Triumph record book.
      3952847349, // Source: The Dawning.
      4041583267, // Source: Festival of the Lost
      4054646289, // Source: Earned during the seasonal Dawning event.
    ],
  },
  eververse: {
    sourceHashes: [
      269962496, // Source: Eververse
      860688654, // Source: Eververse
      2882367429, // Source: Eververse\nComplete the "Vault of Glass" raid to unlock this in Eververse.
      4036739795, // Source: Bright Engrams
    ],
  },
  evidenceboard: {
    sourceHashes: [
      1309588429, // Source: "Chief Investigator" Triumph
      2055289873, // Source: "The Evidence Board" Exotic Quest
    ],
    aliases: ['enclave'],
  },
  exoticquest: {
    sourceHashes: [
      210885364, // Source: Flawless "Presage" Exotic Quest on Master Difficulty
      281362298, // Source: Strider Exotic Quest
      454251931, // Source: "What Remains" Exotic Quest
      483798855, // Source: "The Final Strand" Exotic Quest
      709680645, // Source: "Truly Satisfactory" Triumph
      808611398, // Source: Oblation
      1141831282, // Source: "Of Queens and Worms" Exotic Quest
      1302157812, // Source: Wild Card Exotic Quest
      1388323447, // Source: Exotic Mission "The Whisper"
      1476475066, // Source: "Firmware Update" Triumph
      1730197643, // Source: //node.ovrd.AVALON// Exotic Quest
      1823766625, // Source: "Vox Obscura" Exotic Quest
      1957611613, // Source: An Exotic quest or challenge.
      2055289873, // Source: "The Evidence Board" Exotic Quest
      2068312112, // Source: Exotic Mission "Zero Hour"
      2171520631, // Source: "Lost Lament" Exotic Quest
      2296534980, // Source: Exotic Mission Encore
      2745272818, // Source: "Presage" Exotic Quest
      2856954949, // Source: "Let Loose Thy Talons" Exotic Quest
      3237053501, // Source: Heliostat
      3597879858, // Source: "Presage" Exotic Quest
    ],
    itemHashes: [
      2200470033, // Cull's Shadow
    ],
  },
  fwc: {
    sourceHashes: [
      3569603185, // Source: Earn rank-up packages from Lakshmi-2.
    ],
    enteredDCV: 20,
  },
  gambit: {
    itemHashes: [
      180108390, // Kit and Kaboodle
      180108391, // Dance the Demons Away
      713132408, // Doomsday
      767170345, // Bygones
      810474118, // Trust
      810474119, // Spare Rations
      843171043, // Lonesome
      1277470844, // Backfang
      1335424933, // Gambit Suede
      1335424934, // Gambit Chrome
      1335424935, // Gambit Leather
      1439354195, // Laser Painter
      1661191187, // Mistrust of Gifts
      1996201272, // Bad Omens
      2026755633, // Breakneck
      2224920148, // Gambit Blackguard
      2224920149, // Gambit Steel
      2394866220, // Keep on Drifting
      2588647363, // Live for the Hustle
      2916547559, // Night Watch
      2920648677, // Sole Survivor
      2953199259, // Bottom Dollar
      3001205424, // Ecliptic Distaff
      3001598094, // 21% Delirium
      3217477988, // Gambit Duds
      3327901954, // Bug-Out Bag
      4028000428, // Yesteryear
      4060882457, // Snakeskin Wrap (Ornament)
      4276696962, // Python
      4276696963, // Last Man Standing
    ],
    sourceHashes: [
      186854335, // Source: Gambit
      571102497, // Source: Associated Gambit Quest
      594786771, // Source: Complete this weapon's associated Gambit quest.
      887452441, // Source: Gambit Salvager's Salvo Armament
      1084990426, // The Drifter
      1127923611, // Source: 3 Gambit Rank Resets in a Season
      1162859311, // Source: Complete the "Clean Getaway" quest.
      1465057711, // Source: Standard Ritual Playlist. (Vanguard Ops, Crucible, Gambit)
      2170269026, // Source: Complete Gambit matches and earn rank-up packages from the Drifter.
      2364933290, // Source: Gambit Seasonal Ritual Rank Reward
      2601524261, // Source: Associated Gambit Quest
      2843045413, // Source: Gambit
      2883838366, // Source: Complete the "Breakneck" quest from the Drifter.
      3299964501, // Source: Earn Ranks in Vanguard, Crucible, or Gambit Playlists
      3348906688, // Source: Ranks in Vanguard Strikes, Crucible, or Gambit
      3422985544, // Source: Associated Gambit Quest
      3468619545, // Gambit
      3494247523, // Source: Complete the "Season 8: Keepin' On" quest.
      3522070610, // Source: Gambit
      3942778906, // Source: Drifter Rank Up Reputation
    ],
    aliases: ['drifter'],
  },
  gambitprime: {
    itemHashes: [
      2868525740, // The Collector
      2868525741, // The Invader
      2868525742, // The Reaper
      2868525743, // The Sentry
      3808901541, // Viper Strike
    ],
    sourceHashes: [
      1952675042, // Source: Complete Gambit Prime matches and increase your rank.
    ],
    enteredDCV: 20,
  },
  gardenofsalvation: {
    itemHashes: [
      4103414242, // Divinity
    ],
    sourceHashes: [
      1491707941, // Source: "Garden of Salvation" Raid
    ],
    aliases: ['gos', 'garden'],
  },
  ghostsofthedeep: {
    itemHashes: [
      189194532, // No Survivors (Adept)
      233402416, // New Pacific Epitaph (Adept)
      291447487, // Cold Comfort
      492673102, // New Pacific Epitaph
      839786290, // Cold Comfort
      1050582210, // Greasy Luck (Adept)
      1125217994, // New Pacific Epitaph
      1157220231, // No Survivors (Adept)
      1685406703, // Greasy Luck
      1757202961, // Greasy Luck
      1817605554, // Cold Comfort (Adept)
      2059741649, // New Pacific Epitaph
      2126543269, // Cold Comfort (Adept)
      2760833884, // Cold Comfort
      2934305134, // Greasy Luck
      3185151619, // New Pacific Epitaph (Adept)
      3210739171, // Greasy Luck (Adept)
      3262192268, // No Survivors
      4193602194, // No Survivors
      4228149269, // No Survivors
    ],
    sourceHashes: [
      3288974535, // Source: "Ghosts of the Deep" Dungeon
    ],
    aliases: ['gotd'],
  },
  grasp: {
    sourceHashes: [
      675740011, // Source: "Grasp of Avarice" Dungeon
    ],
  },
  gunsmith: {
    sourceHashes: [
      1459595344, // Source: Purchase from Banshee-44 or Ada-1
      1788267693, // Source: Earn rank-up packages from Banshee-44.
      2986841134, // Source: Salvager's Salvo Armament Quest
      3512613235, // Source: "A Sacred Fusion" Quest
    ],
    aliases: ['banshee'],
  },
  harbinger: {
    sourceHashes: [
      2856954949, // Source: "Let Loose Thy Talons" Exotic Quest
    ],
  },
  haunted: {
    sourceHashes: [
      620369433, // Source: Season of the Haunted Triumph
      976328308, // Source: The Derelict Leviathan
      1283862526, // Source: Season of the Haunted Nightfall Grandmaster
      2273761598, // Source: Season of the Haunted Activities
      2676881949, // Source: Season of the Haunted
    ],
    enteredDCV: 20,
  },
  heliostat: {
    sourceHashes: [
      3237053501, // Source: Heliostat
    ],
  },
  heresy: {
    itemHashes: [
      324584913, // Cold Denial
      2599520828, // Abyssal Edge
      3058845782, // Watchful Eye
      3977827673, // Temptation's Hook
    ],
    sourceHashes: [
      21494224, // Source: Offer the correct final answer in an uncharted space.
      745481267, // Source: Intrinsic Iteration Triumph
      1341921330, // Source: Episode: Heresy Activities
      1792957897, // Source: "Efficient Challenger" Triumph
      2607970476, // Source: Sundered Doctrine
      2869564842, // Source: "Vengeful Knife" Triumph
      3310034131, // Source: "Crossed Blades" Triumph
      3358334503, // Source: "Boon Ghost Mod Collector" Triumph
      3507911332, // Source: Episode: Heresy
    ],
  },
  ikora: {
    sourceHashes: [
      3075817319, // Source: Earn rank-up packages from Ikora Rey.
    ],
  },
  intothelight: {
    itemHashes: [
      52683113, // Blast Furnace
      205225492, // Hung Jury SR4
      211732170, // Hammerhead
      243425374, // Falling Guillotine
      381446446, // Elsie's Rifle
      570866107, // Succession
      697459665, // Hung Jury SR4
      1346714574, // Hammerhead
      2033531688, // Luna's Howl
      2033531689, // Midnight Coup
      2228325504, // Edge Transit
      2480074702, // Forbearance
      2480871539, // Falling Guillotine
      2499720827, // Midnight Coup
      2533990645, // Blast Furnace
      2731922624, // Succession
      3098328572, // The Recluse
      3257283337, // The Recluse
      3736001860, // Forbearance
      3736001861, // The Mountaintop
      3736001863, // Edge Transit
      3757612024, // Luna's Howl
      3851176026, // Elsie's Rifle
      4043921923, // The Mountaintop
    ],
    sourceHashes: [
      1388323447, // Source: Exotic Mission "The Whisper"
      1902517582, // Source: Where's Archie?
      2068312112, // Source: Exotic Mission "Zero Hour"
      2952071500, // Source: Into the Light
    ],
    aliases: ['itl'],
  },
  io: {
    sourceHashes: [
      315474873, // Source: Complete activities and earn rank-up packages on Io.
      1067250718, // Source: Adventure "Arecibo" on Io
      1832642406, // Source: World Quest "Dynasty" on Io.
      2392127416, // Source: Adventure "Cliffhanger" on Io
      2717017239, // Source: Complete Nightfall strike "The Pyramidion."
      3427537854, // Source: Adventure "Road Rage" on Io
    ],
    enteredDCV: 20,
  },
  ironbanner: {
    itemHashes: [
      91672792, // Archon's Thunder
      218787950, // Felwinter's Lie
      218787951, // Gunnora's Axe
      231533811, // Iron Strength
      247984828, // Tinasha's Mastery
      247984829, // Peacebond
      247984830, // Allied Demand
      293709640, // Pressurized Precision
      293709641, // The Wizened Rebuke
      487361141, // Gunnora's Axe
      491956886, // Tusk of the Boar
      540880995, // Dark Decider
      888872889, // Point of the Stag
      1161561386, // The Guiding Sight
      1162929425, // The Golden Standard
      1435062001, // Riiswalker
      1448664466, // Iron Bone
      1448664467, // Iron Gold
      1617917863, // Crimil's Dagger
      1661191199, // Grizzled Wolf
      1764868900, // Riiswalker
      1968711238, // Warlord's Spear
      1987234560, // Iron Ruby
      1999697514, // The Wizened Rebuke
      2189073092, // Lethal Abundance
      2204165992, // The Time-Worn Spire
      2448092902, // Rusted Iron
      2488587246, // The Hero's Burden
      2851703775, // Bite of the Fox
      2881109029, // Roar of the Bear
      3026836571, // Multimach CCX
      3104013318, // Occluded Finality
      3203303472, // Frontier's Cry
      3634548598, // Jorum's Claw
      3634548599, // Claws of the Wolf
      4009352833, // Roar of the Bear
      4222913208, // The Hero's Burden
    ],
    sourceHashes: [
      561111210, // Source: Iron Banner Salvager's Salvo Armament
      1027607603, // Source: Associated Iron Banner Quest
      1312894505, // Source: Iron Banner
      1828622510, // Source: Chance to acquire when you win Iron Banner matches.
      1926923633, // Source: Lord Saladin Rank Up Reputation
      2520862847, // Source: Iron Banner Iron-Handed Diplomacy
      2648408612, // Acquired by competing in the Iron Banner when the wolves were loud.
      3072862693, // Source: Complete Iron Banner matches and earn rank-up packages from Lord Saladin.
    ],
  },
  kepler: {
    sourceHashes: [
      4284811963, // Source: Exploring Kepler
    ],
  },
  kingsfall: {
    sourceHashes: [
      160129377, // Source: "King's Fall" Raid
    ],
    aliases: ['kf'],
  },
  lastwish: {
    itemHashes: [
      3668669364, // Dreaming Spectrum
    ],
    sourceHashes: [
      2455011338, // Source: Last Wish raid.
    ],
    aliases: ['lw'],
  },
  legendaryengram: {
    itemHashes: [
      324584912, // Ogma PR6
      734476286, // Maahes HC4
      870893339, // Ded Gramarye IV
      960948343, // True Prophecy
      1291040555, // Heliocentric QSc
      1402874079, // Hawthorne's Field-Forged Shotgun
      1517780158, // The Deicide
      1525080480, // Battle Scar
      1979417829, // Nasreddin
      2366022261, // Nox Perennial V
      3156551028, // Glissando-47
      3156551029, // Admetus-D
      3156551031, // Live Fire
      3719824177, // Cartesian Coordinate
      3769072067, // Parabellum
      3786215462, // Aurvandil FR6
      4118936670, // Last Foray
    ],
    sourceHashes: [
      3334812276, // Source: Open Legendary engrams and earn faction rank-up packages.
    ],
  },
  leviathan: {
    itemHashes: [
      3580904580, // Legend of Acrius
    ],
    sourceHashes: [
      2653618435, // Source: Leviathan raid.
      2765304727, // Source: Leviathan raid on Prestige difficulty.
      4009509410, // Source: Complete challenges in the Leviathan raid.
    ],
    enteredDCV: 20,
  },
  lost: {
    sourceHashes: [
      164083100, // Source: Display of Supremacy, Weekly Challenge
      3094114967, // Source: Season of the Lost Ritual Playlists
    ],
    enteredDCV: 20,
  },
  lostsectors: {
    sourceHashes: [
      2203185162, // Source: Solo Expert and Master Lost Sectors
    ],
  },
  mars: {
    sourceHashes: [
      1036506031, // Source: Complete activities and earn rank-up packages on Mars.
      1299614150, // Source: [REDACTED] on Mars.
      1924238751, // Source: Complete Nightfall strike "Will of the Thousands."
      2310754348, // Source: World Quest "Data Recovery" on Mars.
      2926805810, // Source: Complete Nightfall strike "Strange Terrain."
      4137108180, // Source: Escalation Protocol on Mars.
    ],
    enteredDCV: 20,
  },
  menagerie: {
    itemHashes: [
      1661191194, // A Hall of Delights
      1661191195, // The Imperial Menagerie
      3176509806, // Árma Mákhēs
      3841416152, // Golden Empire
      3841416153, // Goldleaf
      3841416154, // Shadow Gilt
      3841416155, // Cinderchar
      3875444086, // The Emperor's Chosen
    ],
    sourceHashes: [
      2511152325, // Acquired from the Menagerie aboard the Leviathan.
    ],
    enteredDCV: 20,
  },
  mercury: {
    itemHashes: [
      3176697588, // Infinite Paths 8
    ],
    sourceHashes: [
      148542898, // Source: Equip the full Mercury destination set on a Warlock.
      1175566043, // Source: Complete Nightfall strike "A Garden World."
      1400219831, // Source: Equip the full Mercury destination set on a Hunter.
      1411886787, // Source: Equip the full Mercury destination set on a Titan.
      1581680964, // Source: Complete Nightfall strike "Tree of Probabilities."
      1618754228, // Source: Sundial Activity on Mercury
      1654120320, // Source: Complete activities and earn rank-up packages on Mercury.
      2487203690, // Source: Complete Nightfall strike "Tree of Probabilities."
      3079246067, // Source: Complete Osiris' Lost Prophecies for Brother Vance on Mercury.
      3964663093, // Source: Rare drop from high-scoring Nightfall strikes on Mercury.
      4263201695, // Source: Complete Nightfall strike "A Garden World."
    ],
    enteredDCV: 20,
  },
  monumentoftriumph: {
    sourceHashes: [
      1658014144, // Source: Monument of Triumph
      2224236308, // Arena Ops
      2371297108, // Worlds: Distortions
      2387628034, // Source: Monument of Triumph
      2908547701, // Cosmodrome
      3457438830, // Solo Ops
      4222891848, // Fireteam Ops
    ],
    aliases: ['mot'],
  },
  moon: {
    itemHashes: [
      219610523, // Dream Breaker
      846241148, // Tranquility
      846241149, // Apostate
      868076517, // Loud Lullaby
      1487476133, // Every Waking Moment
      2136808079, // Heretic
      2527058296, // One Small Step
      2527058297, // Blasphemer
      2729232863, // Night Terror
      3211332727, // A Fine Memorial
      3482299617, // Love and Death
    ],
    sourceHashes: [
      1253026984, // Source: Among the lost Ghosts of the Moon.
      1999000205, // Source: Exploring the Moon
      3062439457, // The Moon
      3589340943, // Source: Altars of Sorrow
    ],
  },
  neomuna: {
    itemHashes: [
      1123421440, // Epochal Integration
      2353274446, // Basso Ostinato
      2528793321, // Circular Logic
      3752860091, // Synchronic Roulette
      3851394887, // Epochal Integration
    ],
    sourceHashes: [
      281362298, // Source: Strider Exotic Quest
      454251931, // Source: "What Remains" Exotic Quest
      483798855, // Source: "The Final Strand" Exotic Quest
      1750523507, // Source: Terminal Overload (Ahimsa Park)
      2697389955, // Source: "Neomuna Sightseeing" Triumph
      3041847664, // Source: Exploring Neomuna
      3773376290, // Source: Terminal Overload (Zephyr Concourse)
      4006434081, // Source: Terminal Overload
      4110186790, // Source: Terminal Overload (Límíng Harbor)
    ],
  },
  nessus: {
    sourceHashes: [
      164571094, // Source: World Quest "Exodus Black" on Nessus.
      779585227, // Nessus, Unstable Centaur
      817015032, // Source: Complete Nightfall strike "The Inverted Spire."
      1186140085, // Source: Adventure "Unbreakable" on Nessus
      1289998337, // Source: Adventure "Hack the Planet" on Nessus
      1906492169, // Source: Complete activities and earn rank-up packages on Nessus.
      2040548068, // Source: Adventure "Release" on Nessus
      2345202459, // Source: Adventure "Invitation from the Emperor" on Nessus
      2553369674, // Source: Adventure "Exodus Siege" on Nessus
      3022766747, // Source: Complete Nightfall strike "The Insight Terminus."
      3067146211, // Source: Complete Nightfall strike "Exodus Crash."
    ],
  },
  nightfall: {
    itemHashes: [
      42874240, // Uzume RR4
      192784503, // Pre Astyanax IV
      213264394, // Buzzard
      233635202, // Cruel Mercy
      267089201, // Warden's Law (Adept)
      496556698, // Pre Astyanax IV (Adept)
      555148853, // Wendigo GL3 (Adept)
      566740455, // THE SWARM (Adept)
      672957262, // Undercurrent (Adept)
      739029152, // The Palindrome
      739029153, // D.F.A.
      772231794, // Hung Jury SR4
      817909300, // Undercurrent (Adept)
      827835657, // Horror's Least
      852069910, // Loaded Question
      852069911, // PLUG ONE.1
      912222548, // Soldier On
      924095500, // Lotus-Eater
      927835311, // Buzzard (Adept)
      959037361, // Wild Style (Adept)
      1056103557, // Shadow Price (Adept)
      1064132738, // BrayTech Osprey (Adept)
      1151688091, // Undercurrent
      1207321710, // Scintillation
      1332123064, // Wild Style
      1354727549, // The Slammer (Adept)
      1492522228, // Scintillation (Adept)
      1586231351, // Mindbender's Ambition
      1692372662, // The Hothead
      1821529912, // Warden's Law
      1854753404, // Wendigo GL3
      1854753405, // The Militia's Birthright
      1891996599, // Uzume RR4 (Adept)
      1987790789, // After the Nightfall
      2063217087, // Pre Astyanax IV (Adept)
      2074041946, // Mindbender's Ambition (Adept)
      2152484073, // Warden's Law
      2201323795, // Rake Angle
      2298039571, // Rake Angle
      2322926844, // Shadow Price
      2347178967, // Cruel Mercy (Adept)
      2363113134, // Warden's Law
      2450917538, // Uzume RR4
      2466028274, // The Slammer
      2591257541, // Scintillation
      2697143634, // Lotus-Eater (Adept)
      2759590322, // THE SWARM
      2876244791, // The Palindrome
      2883684343, // Hung Jury SR4 (Adept)
      2889501828, // The Slammer
      2914913838, // Loaded Question (Adept)
      2932922810, // Pre Astyanax IV
      3106557243, // PLUG ONE.1 (Adept)
      3125454907, // Loaded Question
      3183283212, // Wendigo GL3
      3250744600, // Warden's Law (Adept)
      3293524502, // PLUG ONE.1
      3610521673, // Uzume RR4 (Adept)
      3667553455, // BrayTech Osprey
      3686538757, // Undercurrent
      3832743906, // Hung Jury SR4
      3915197957, // Wendigo GL3 (Adept)
      3922217119, // Lotus-Eater
      3997086838, // Rake Angle (Adept)
      4011513985, // Cruel Mercy
      4021098352, // Wild Style
      4021098353, // Wendigo GL3
      4037675261, // Uzume RR4
      4074251943, // Hung Jury SR4 (Adept)
      4077588826, // The Palindrome (Adept)
      4162642204, // The Militia's Birthright (Adept)
      4237970862, // Buzzard
    ],
    sourceHashes: [
      110159004, // Source: Complete Nightfall strike "Warden of Nothing."
      277706045, // Source: Season of the Splicer Nightfall Grandmaster
      354493557, // Source: Complete Nightfall strike "Savathûn's Song."
      817015032, // Source: Complete Nightfall strike "The Inverted Spire."
      827839814, // Source: Flawless Chest in Trials of Osiris or Grandmaster Nightfalls
      860666126, // Source: Nightfall
      1175566043, // Source: Complete Nightfall strike "A Garden World."
      1283862526, // Source: Season of the Haunted Nightfall Grandmaster
      1516560855, // Source: Season of the Seraph Grandmaster Nightfall
      1581680964, // Source: Complete Nightfall strike "Tree of Probabilities."
      1596489410, // Source: Season of the Risen Nightfall Grandmaster
      1618699950, // Source: Season of the Lost Nightfall Grandmaster
      1749037998, // Source: Nightfall
      1850609592, // Source: Nightfall
      1924238751, // Source: Complete Nightfall strike "Will of the Thousands."
      1992319882, // Source: Grandmaster Nightfalls
      2347293565, // Source: Complete Nightfall strike "The Arms Dealer."
      2376909801, // Source: "Master" Triumph in Nightfalls
      2487203690, // Source: Complete Nightfall strike "Tree of Probabilities."
      2717017239, // Source: Complete Nightfall strike "The Pyramidion."
      2805208672, // Source: Complete Nightfall strike "The Hollowed Lair."
      2851783112, // Source: Complete Nightfall strike "Lake of Shadows."
      2926805810, // Source: Complete Nightfall strike "Strange Terrain."
      2982642634, // Source: Season of Plunder Grandmaster Nightfall
      3022766747, // Source: Complete Nightfall strike "The Insight Terminus."
      3067146211, // Source: Complete Nightfall strike "Exodus Crash."
      3142874552, // Source: Nightfall
      3229688794, // Source: Grandmaster Nightfall
      3528789901, // Source: Season of the Chosen Nightfall Grandmaster
      3874934421, // Source: Complete Nightfall strike "The Corrupted."
      3964663093, // Source: Rare drop from high-scoring Nightfall strikes on Mercury.
      4208190159, // Source: Complete a Nightfall strike.
      4263201695, // Source: Complete Nightfall strike "A Garden World."
    ],
  },
  nightmare: {
    sourceHashes: [
      550270332, // Source: Complete all Nightmare Hunt time trials on Master difficulty.
      2778435282, // Source: Nightmare Hunts
    ],
  },
  nm: {
    sourceHashes: [
      1464399708, // Source: Earn rank-up packages from Executor Hideo.
    ],
    enteredDCV: 20,
  },
  oblation: {
    itemHashes: [
      2200470033, // Cull's Shadow
    ],
    sourceHashes: [
      808611398, // Source: Oblation
    ],
  },
  paleheart: {
    sourceHashes: [
      941123623, // Pale Heart - Cayde's Stash
      2327253880, // Source: Exploring the Pale Heart
      3614199681, // Source: Pale Heart Triumph
    ],
  },
  pantheon: {
    sourceHashes: [
      383611049, // Source: Pantheon
    ],
  },
  'pinnacle-weapon': {
    itemHashes: [
      61391690, // Hush
      444627789, // Oxygen SR3
      578459533, // Wendigo GL3
      631405394, // The Recluse
      654608616, // Revoker
      1050806815, // The Recluse
      1584643826, // Hush
      1600633250, // 21% Delirium
      3001598094, // 21% Delirium
      3098328572, // The Recluse
      3257283337, // The Recluse
      3354242550, // The Recluse
      3638723317, // Hush
      3907337522, // Oxygen SR3
      3962575203, // Hush
      4104613038, // Oxygen SR3
      4139847991, // 21% Delirium
    ],
    sourceHashes: [
      598662729, // Source: Reach Glory Rank "Legend" in the Crucible.
      1162859311, // Source: Complete the "Clean Getaway" quest.
      1244908294, // Source: Complete the "Loaded Question" quest from Zavala.
      2317365255, // Source: Complete the "A Loud Racket" quest.
      2883838366, // Source: Complete the "Breakneck" quest from the Drifter.
    ],
  },
  pinnacleops: {
    sourceHashes: [
      1232061833, // Source: Pinnacle Ops
    ],
  },
  pit: {
    itemHashes: [
      1969802090, // Premonition
    ],
    sourceHashes: [
      1745960977, // Source: "Pit of Heresy" Dungeon
    ],
  },
  plunder: {
    itemHashes: [
      768696858, // Cry Mutiny
    ],
    sourceHashes: [
      790152021, // Source: Season of Plunder Triumph
      2982642634, // Source: Season of Plunder Grandmaster Nightfall
      3265560237, // Source: Cryptic Quatrains III
      3308438907, // Source: Season of Plunder
      3740731576, // Source: "A Rising Tide" Mission
      4199401779, // Source: Season of Plunder Activities
    ],
    enteredDCV: 20,
  },
  presage: {
    sourceHashes: [
      210885364, // Source: Flawless "Presage" Exotic Quest on Master Difficulty
      2745272818, // Source: "Presage" Exotic Quest
      3597879858, // Source: "Presage" Exotic Quest
    ],
  },
  prestige: {
    sourceHashes: [
      2765304727, // Source: Leviathan raid on Prestige difficulty.
      2812190367, // Source: Leviathan, Spire of Stars raid lair on Prestige difficulty.
      4066007318, // Source: Leviathan, Eater of Worlds raid lair on Prestige difficulty.
    ],
    enteredDCV: 20,
  },
  prophecy: {
    itemHashes: [
      435821040, // Darkest Before
      435821041, // Relentless
      749483159, // Prosecutor (Adept)
      880829467, // Prosecutor
      1013434963, // Adjudicator
      1066598837, // Relentless (Adept)
      1626437786, // A Sudden Death (Adept)
      1773934241, // Judgment
      1827058652, // Relentless (Adept)
      1904170910, // A Sudden Death
      1976481399, // A Sudden Death
      1987644603, // Judgment (Adept)
      2129814338, // Prosecutor
      2130249527, // Death Adder
      2226572694, // Judgment
      2764074355, // A Sudden Death (Adept)
      2969415423, // Judgment
      3329218848, // Judgment (Adept)
      3483591058, // Prosecutor
      3681280908, // Relentless
      3733988413, // Relentless
      4025177550, // Prosecutor (Adept)
      4097972038, // A Sudden Death
    ],
    sourceHashes: [
      506073192, // Source: "Prophecy" Dungeon
    ],
  },
  psiops: {
    itemHashes: [
      1291040554, // Brass Attacks
    ],
    sourceHashes: [
      450719423, // Source: Season of the Risen
      2075569025, // PsiOps
      2363489105, // Source: Season of the Risen Vendor or Triumphs
      3563833902, // Source: Season of the Risen Triumphs
    ],
    enteredDCV: 24,
  },
  rahool: {
    sourceHashes: [
      4011186136, // Exotic Armor Focusing
    ],
  },
  raid: {
    sourceHashes: [
      160129377, // Source: "King's Fall" Raid
      383611049, // Source: Pantheon
      557146120, // Source: Complete a Guided Game as a guide or seeker.
      596084342, // Source: "The Desert Perpetual" Raid
      654652973, // Guide 25 Last Wish encounters
      707740602, // Guide 10 Last Wish encounters
      866530798, // Source: "Not a Scratch" Triumph
      1007078046, // Source: "Vow of the Disciple" Raid
      1405897559, // Source: "Deep Stone Crypt" Raid
      1483048674, // Source: Complete the "Scourge of the Past" raid.
      1491707941, // Source: "Garden of Salvation" Raid
      1675483099, // Source: Leviathan, Spire of Stars raid lair.
      1692165595, // Source: "Rock Bottom" Triumph
      1897187034, // Source: "Crota's End" Raid
      2065138144, // Source: "Vault of Glass" Raid
      2085016678, // Source: Complete the "Scourge of the Past" raid within the first 24 hours after its launch.
      2127551856, // Source: "The Desert Perpetual" Epic Raid
      2399751101, // Acquired from the raid "Crown of Sorrow."
      2455011338, // Source: Last Wish raid.
      2653618435, // Source: Leviathan raid.
      2700267533, // Source: "Salvation's Edge" Raid
      2723305286, // Source: Raid Ring Promotional Event
      2765304727, // Source: Leviathan raid on Prestige difficulty.
      2812190367, // Source: Leviathan, Spire of Stars raid lair on Prestige difficulty.
      2882367429, // Source: Eververse\nComplete the "Vault of Glass" raid to unlock this in Eververse.
      2937902448, // Source: Leviathan, Eater of Worlds raid lair.
      3098906085, // Source: Complete a Guided Game raid as a guide.
      3147603678, // Acquired from the raid "Crown of Sorrow."
      3190710249, // Source: "Root of Nightmares" Raid
      3390269646, // Source: Guided Games Final Encounters
      3807243511, // Source: Raid Chests
      4009509410, // Source: Complete challenges in the Leviathan raid.
      4066007318, // Source: Leviathan, Eater of Worlds raid lair on Prestige difficulty.
      4246883461, // Source: Found in the "Scourge of the Past" raid.
    ],
    itemHashes: [
      412265080, // Bellowing Giant
      947448544, // Shadow of Earth Shell
      1271275406, // No Feelings
      1661191193, // Crown of Sorrow
      2027598066, // Imperial Opulence
      2027598067, // Imperial Dress
      2274706510, // Tempered Dynamo
      2557722678, // Midnight Smith
      3580904580, // Legend of Acrius
      3668669364, // Dreaming Spectrum
      4103414242, // Divinity
    ],
  },
  rasputin: {
    itemHashes: [
      453798564, // Seventh Seraph SI-2
      2584201248, // Seventh Seraph SAW
    ],
    sourceHashes: [
      504657809, // Source: Season of the Seraph Activities
      1126234343, // Source: Witness Rasputin's Full Power
      1497107113, // Source: Seasonal Quest, "Seraph Warsat Network"
      1516560855, // Source: Season of the Seraph Grandmaster Nightfall
      2230358252, // Source: End-of-Season Event
      2422551147, // Source: "Operation Seraph's Shield" Mission
      3492941398, // Source: "The Lie" Quest
      3567813252, // Source: Season of the Seraph Triumph
      3574140916, // Source: Season of the Seraph
      3937492340, // Source: Seraph Bounties
    ],
    enteredDCV: 20,
  },
  reclaim: {
    sourceHashes: [
      2929839827, // Source: Reclaim
    ],
  },
  renegades: {
    sourceHashes: [
      178383754, // Source: Renegades
    ],
  },
  revenant: {
    itemHashes: [
      736362511, // Red Tape
      2596736862, // Insurmountable
      3176697589, // Gridskipper
      3377522331, // Liturgy
    ],
    sourceHashes: [
      792439255, // Source: Tonic Laboratory in the Last City
      1605890568, // Source: Episode Revenant Seasonal Activities
      2463956052, // Source: Vesper's Host
      3906217258, // Source: Revenant Fortress
    ],
  },
  riteofthenine: {
    itemHashes: [
      14929251, // Long Arm
      492673102, // New Pacific Epitaph
      749483159, // Prosecutor (Adept)
      1050582210, // Greasy Luck (Adept)
      1066598837, // Relentless (Adept)
      1157220231, // No Survivors (Adept)
      1460079227, // Liminal Vigil
      1685406703, // Greasy Luck
      1773934241, // Judgment
      1904170910, // A Sudden Death
      1987644603, // Judgment (Adept)
      2126543269, // Cold Comfort (Adept)
      2129814338, // Prosecutor
      2477408004, // Wilderflight (Adept)
      2730671571, // Terminus Horizon
      2760833884, // Cold Comfort
      2764074355, // A Sudden Death (Adept)
      2982006965, // Wilderflight
      3185151619, // New Pacific Epitaph (Adept)
      3329218848, // Judgment (Adept)
      3421639790, // Liminal Vigil (Adept)
      3681280908, // Relentless
      3692140710, // Long Arm (Adept)
      4193602194, // No Survivors
      4267192886, // Terminus Horizon (Adept)
    ],
    sourceHashes: [
      877404349, // Source: Rite of the Nine
    ],
    aliases: ['rotn'],
  },
  'ritual-weapon': {
    itemHashes: [
      218787950, // Felwinter's Lie
      438540299, // Veles-X
      805677041, // Buzzard
      838556752, // Python
      847329160, // Edgewise
      891765152, // Adored
      938936806, // Chivalric Fire
      979721268, // Malediction
      1179141605, // Felwinter's Lie
      1208809704, // Ecliptic Distaff
      1405095983, // Adored
      1458073737, // Python
      1644680957, // Null Composure
      1692109318, // Salvager's Salvo
      1713388226, // Ascendancy
      1716620044, // Chain of Command
      1942143745, // Ecliptic Distaff
      2060863616, // Salvager's Salvo
      2150643740, // Null Composure
      2191451996, // Perfect Pitch
      2454230106, // Adored
      2461640837, // Salvager's Salvo
      2697058914, // Komodo-4FR
      2963863503, // Salvager's Salvo
      3001205424, // Ecliptic Distaff
      3085559077, // Reckless Endangerment
      3273807888, // Resounding
      3434944005, // Point of the Stag
      3535742959, // Randy's Throwing Knife
      3613444087, // Null Composure
      3708636616, // Last Rite
      3719002817, // Felwinter's Lie
      4162333225, // Null Composure
      4184808992, // Adored
      4227181568, // Exit Strategy
      4276696962, // Python
    ],
    sourceHashes: [
      3299964501, // Source: Earn Ranks in Vanguard, Crucible, or Gambit Playlists
      3348906688, // Source: Ranks in Vanguard Strikes, Crucible, or Gambit
    ],
  },
  rivenslair: {
    sourceHashes: [
      561126969, // Source: "Starcrossed" Mission
      1664308183, // Source: Season of the Wish Activities
      4278841194, // Source: Season of the Wish Triumphs
    ],
    aliases: ['coil'],
    enteredDCV: 24,
  },
  rootofnightmares: {
    sourceHashes: [
      3190710249, // Source: "Root of Nightmares" Raid
    ],
    aliases: ['root', 'ron'],
  },
  saint14: {
    sourceHashes: [
      2607739079, // Source: A Matter of Time
      3404977524, // Source: Contribute to the Empyrean Restoration Effort
      4046490681, // Source: Complete the "Global Resonance" Triumph
      4267157320, // Source: ???????
    ],
    enteredDCV: 20,
  },
  salvationsedge: {
    sourceHashes: [
      2700267533, // Source: "Salvation's Edge" Raid
    ],
  },
  scourgeofthepast: {
    itemHashes: [
      412265080, // Bellowing Giant
      1271275406, // No Feelings
      2274706510, // Tempered Dynamo
      2557722678, // Midnight Smith
    ],
    sourceHashes: [
      1483048674, // Source: Complete the "Scourge of the Past" raid.
      2085016678, // Source: Complete the "Scourge of the Past" raid within the first 24 hours after its launch.
      4246883461, // Source: Found in the "Scourge of the Past" raid.
    ],
    aliases: ['scourge', 'sotp'],
    enteredDCV: 20,
  },
  seasonpass: {
    itemHashes: [
      1719169808, // Seventh Seraph VY-7
      2308010345, // Seventh Seraph CQC-12
      2566169398, // Trophy Hunter
      3132669561, // Temporal Clause
      3161496501, // Pyroclastic Flow
    ],
    sourceHashes: [
      333761108, // Source: Rewards Pass
      450719423, // Source: Season of the Risen
      794422188, // Source: Season of the Witch
      813075729, // Source: Season of the Deep Vendor Reputation Reward
      927967626, // Source: Season of the Deep
      1560428737, // Source: Season of Defiance
      1593696611, // Source: Season Pass Reward
      1763998430, // Source: Season Pass
      1838401392, // Source: Earned as a Season Pass reward.
      2257836668, // Source: Season of the Deep Fishing
      2379344669, // Source: Season Pass
      2676881949, // Source: Season of the Haunted
      2986594962, // Source: Season of the Wish
      3308438907, // Source: Season of Plunder
      3574140916, // Source: Season of the Seraph
    ],
  },
  servitor: {
    itemHashes: [
      599895591, // Sojourner's Tale
      2130875369, // Sojourner's Tale
      2434225986, // Shattered Cipher
    ],
    sourceHashes: [
      139160732, // Source: Season of the Splicer
      277706045, // Source: Season of the Splicer Nightfall Grandmaster
      1600754038, // Source: Season of the Splicer Activities
      2040801502, // Source: Season of the Splicer Triumph
      2694738712, // Source: Season of the Splicer Quest
      2967385539, // Source: Season of the Splicer Seasonal Challenges
    ],
    enteredDCV: 20,
  },
  shatteredthrone: {
    itemHashes: [
      185321778, // The Eternal Return
      814876684, // Wish-Ender
      2844014413, // Pallas Galliot
    ],
  },
  shipwright: {
    sourceHashes: [
      96303009, // Source: Purchased from Amanda Holliday.
    ],
    enteredDCV: 20,
  },
  sonar: {
    sourceHashes: [
      813075729, // Source: Season of the Deep Vendor Reputation Reward
      927967626, // Source: Season of the Deep
      2257836668, // Source: Season of the Deep Fishing
      2671038131, // Season of the Deep - WEAPONS
      2755511565, // Source: Season of the Deep Triumph
      2811716495, // Source: Season of the Deep Activities
      2959452483, // Season of the Deep - WEAPONS
    ],
    enteredDCV: 24,
  },
  sparrowracingleague: {
    sourceHashes: [
      4077197178, // Source: Sparrow Racing League
    ],
    aliases: ['srl'],
  },
  spireofstars: {
    sourceHashes: [
      1675483099, // Source: Leviathan, Spire of Stars raid lair.
      2812190367, // Source: Leviathan, Spire of Stars raid lair on Prestige difficulty.
    ],
    aliases: ['sos'],
    enteredDCV: 20,
  },
  spireofthewatcher: {
    itemHashes: [
      8293111, // Long Arm
      14929251, // Long Arm
      487205709, // Terminus Horizon
      559523765, // Wilderflight (Adept)
      1206729100, // Wilderflight
      1460079227, // Liminal Vigil
      1905934655, // Liminal Vigil (Adept)
      2210806903, // Terminus Horizon (Adept)
      2306182339, // Wilderflight
      2477408004, // Wilderflight (Adept)
      2575844666, // Liminal Vigil
      2730671571, // Terminus Horizon
      2982006965, // Wilderflight
      3138208275, // Liminal Vigil
      3421639790, // Liminal Vigil (Adept)
      3490736392, // Seventh Seraph Officer Revolver
      3692140710, // Long Arm (Adept)
      3984556130, // Terminus Horizon
      4059111040, // Survivor's Epitaph
      4239378215, // Long Arm (Adept)
      4249949938, // Long Arm
      4267192886, // Terminus Horizon (Adept)
    ],
    sourceHashes: [
      1597738585, // Source: "Spire of the Watcher" Dungeon
    ],
    aliases: ['sotw', 'watcher'],
  },
  strikes: {
    itemHashes: [
      34731066, // Nightshade
      42874240, // Uzume RR4
      63899322, // Smoke Jumper Boots
      81786728, // Bushido Grips
      95722356, // Techsec Boots
      192784503, // Pre Astyanax IV
      198068259, // Empty Vessel
      213264394, // Buzzard
      233635202, // Cruel Mercy
      262826703, // Swordmaster's Plate
      274843196, // Vanguard Unyielding
      293267476, // Ferropotent Cloak
      385833378, // Swordmaster's Cloak
      407922163, // Bushido Helm
      433193440, // Eutechnology Plate
      445076215, // Swordmaster's Strides
      464665629, // Bushido Cloak
      489126477, // Techsec Gloves
      503854896, // Techsec Vest
      517096395, // Techsec Helm
      545935602, // Bushido Cowl
      589006711, // Smoke Jumper Gauntlets
      591555944, // Eutechnology Gauntlets
      593554567, // Luminopotent Mask
      726639044, // Eutechnology Vest
      743956488, // Bushido Bond
      772231794, // Hung Jury SR4
      781498181, // Persuader
      951529995, // Mindbender's Ambition
      963732594, // Xenoclast IV
      963732595, // Fortissimo-11
      970712027, // Bushido Gloves
      986078848, // Smoke Jumper Gloves
      1003997240, // Smoke Jumper Cloak
      1047792392, // Luminopotent Strides
      1057430865, // Ferropotent Bond
      1066619413, // Ferropotent Cover
      1151688091, // Undercurrent
      1152238701, // Eutechnology Cowl
      1154629600, // Bushido Vest
      1159925519, // Techsec Boots
      1183125954, // Bushido Strides
      1232186726, // Eutechnology Strides
      1248547982, // Ferropotent Boots
      1296429091, // Deadpan Delivery
      1332123064, // Wild Style
      1343009820, // Swordmaster's Mask
      1465235089, // Bushido Cowl
      1469372193, // Punching Out
      1504698788, // Swordmaster's Robes
      1575046822, // Smoke Jumper Helm
      1589715538, // Techsec Strides
      1604556427, // Swordmaster's Vest
      1619647653, // Smoke Jumper Bond
      1661191186, // Disdain for Gold
      1683071779, // Eutechnology Boots
      1689821714, // Luminopotent Greaves
      1692895170, // Eutechnology Greaves
      1821529912, // Warden's Law
      1829877749, // Luminopotent Boots
      1851922001, // Eutechnology Gloves
      1854753404, // Wendigo GL3
      1854753405, // The Militia's Birthright
      1883377784, // Swordmaster's Helm
      1924898304, // Luminopotent Bond
      1934339678, // Swordmaster's Mark
      1936503321, // Eutechnology Cloak
      1957301533, // Nameless Midnight
      1963424554, // Techsec Bond
      1966593658, // Luminopotent Cover
      1974641289, // Nightshade
      1975004305, // Eutechnology Helm
      1999754402, // The Showrunner
      2046361909, // Bushido Robes
      2082858804, // Techsec Hood
      2107326067, // Luminopotent Cloak
      2152484073, // Warden's Law
      2192886829, // Luminopotent Mark
      2195895938, // Bushido Gauntlets
      2199272806, // Bushido Plate
      2248528889, // Swordmaster's Bond
      2270938588, // Eutechnology Sleeves
      2280816555, // Smoke Jumper Grasps
      2292070913, // Techsec Mask
      2298039571, // Rake Angle
      2322926844, // Shadow Price
      2347181257, // Swordmaster's Gauntlets
      2348082405, // Smoke Jumper Vest
      2370945771, // Ferropotent Gauntlets
      2397541401, // Smoke Jumper Boots
      2401760398, // Techsec Plate
      2450917538, // Uzume RR4
      2517367247, // Bushido Mark
      2523776412, // Vanguard Burnished Steel
      2523776413, // Vanguard Steel
      2588647361, // Consequence of Duty
      2591257541, // Scintillation
      2624561525, // Prolonged Engagement
      2639123099, // Swordmaster's Greaves
      2676446840, // Ferropotent Mark
      2697887125, // Swordmaster's Grips
      2709760314, // Techsec Gauntlets
      2719854935, // Techsec Mark
      2759590322, // THE SWARM
      2788911997, // Vanguard Divide
      2788911998, // Vanguard Metallic
      2788911999, // Vanguard Veteran
      2816737729, // Luminopotent Helm
      2827141087, // Cynosure
      2835120910, // Luminopotent Grips
      2849508185, // Ferropotent Cuirass
      2876244791, // The Palindrome
      2883433250, // Luminopotent Cuirass
      2889501828, // The Slammer
      2897411591, // Eutechnology Robes
      2932922810, // Pre Astyanax IV
      2941172034, // Smoke Jumper Mask
      3001205424, // Ecliptic Distaff
      3031404418, // Ferropotent Head
      3120202721, // Ferropotent Strides
      3125454907, // Loaded Question
      3129990424, // Techsec Grasps
      3173749166, // Ferropotent Mask
      3183283212, // Wendigo GL3
      3215252549, // Determination
      3293524502, // PLUG ONE.1
      3307308272, // Luminopotent Plate
      3345056013, // Luminopotent Robes
      3347493825, // Smoke Jumper Plate
      3462703357, // Ferropotent Greaves
      3520307277, // Swordmaster's Cover
      3554497829, // Ferropotent Plate
      3558781766, // Swordmaster's Boots
      3577550601, // Smoke Jumper Hood
      3654657240, // Luminopotent Gauntlets
      3667553455, // BrayTech Osprey
      3686538757, // Undercurrent
      3715719501, // Bushido Boots
      3737830979, // Luminopotent Gloves
      3744058588, // The Third Axiom
      3755454909, // Smoke Jumper Strides
      3788059976, // Smoke Jumper Vestment
      3796682229, // Service Revolver
      3832743906, // Hung Jury SR4
      3922217119, // Lotus-Eater
      4037429988, // Ferropotent Gloves
      4038196765, // Eutechnology Mark
      4045298482, // Spoiler Alert
      4045298483, // The Last Dance
      4046741099, // Main Ingredient
      4052965875, // Techsec Vestment
      4060882458, // Balistraria Wrap (Ornament)
      4066564572, // Ferropotent Robes
      4078840342, // Eutechnology Bond
      4129998876, // Smoke Jumper Mark
      4150538093, // Techsec Cloak
      4172973116, // Swordmaster's Gloves
      4199055647, // Ferropotent Grips
      4281618492, // Bushido Greaves
      4285848704, // Eutechnology Cover
    ],
    sourceHashes: [
      288436121, // Source: Associated Vanguard Quest
      351235593, // Source: Eliminate Prison of Elders escapees found in strikes.
      412991783, // Source: Strikes
      539840256, // Source: Associated Vanguard Quest
      1144274899, // Source: Complete this weapon's associated Vanguard quest.
      1216155659, // Source: Complete the "Season 8: First Watch" quest.
      1244908294, // Source: Complete the "Loaded Question" quest from Zavala.
      1433518193, // Source: Vanguard Salvager's Salvo Armament Quest
      1465057711, // Source: Standard Ritual Playlist. (Vanguard Ops, Crucible, Gambit)
      1564061133, // Source: Associated Vanguard Quest
      2124937714, // Source: Zavala Rank Up Reputation
      2317365255, // Source: Complete the "A Loud Racket" quest.
      2335095658, // Source: Strikes
      2527168932, // Source: Complete strikes and earn rank-up packages from Commander Zavala.
      3299964501, // Source: Earn Ranks in Vanguard, Crucible, or Gambit Playlists
      3348906688, // Source: Ranks in Vanguard Strikes, Crucible, or Gambit
      3405421310, // Commander Zavala
    ],
    aliases: ['zavala'],
  },
  sundereddoctrine: {
    itemHashes: [
      1303313141, // Unsworn
      2226158470, // Unworthy
      2485881870, // Unloved
      3360937899, // Unvoiced
    ],
    sourceHashes: [
      2607970476, // Source: Sundered Doctrine
    ],
    aliases: ['sundered'],
  },
  sundial: {
    sourceHashes: [
      1618754228, // Source: Sundial Activity on Mercury
      2627087475, // Source: Obelisk Bounties and Resonance Rank Increases Across the System
    ],
    enteredDCV: 20,
  },
  tangled: {
    itemHashes: [
      1226584228, // Tangled Rust
      1226584229, // Tangled Bronze
      4085986809, // Secret Treasure
    ],
    sourceHashes: [
      110159004, // Source: Complete Nightfall strike "Warden of Nothing."
      798957490, // Source: Complete wanted escapee bounties for the Spider.
      1771326504, // Source: Complete activities and earn rank-up packages on the Tangled Shore.
      2805208672, // Source: Complete Nightfall strike "The Hollowed Lair."
      4140654910, // Source: Eliminate all Barons on the Tangled Shore.
    ],
    enteredDCV: 20,
  },
  throneworld: {
    sourceHashes: [
      1141831282, // Source: "Of Queens and Worms" Exotic Quest
      1823766625, // Source: "Vox Obscura" Exotic Quest
      3954922099, // Source: Exploring the Throne World
    ],
  },
  titan: {
    sourceHashes: [
      194661944, // Source: Adventure "Siren Song" on Saturn's Moon, Titan
      354493557, // Source: Complete Nightfall strike "Savathûn's Song."
      482012099, // Source: Adventure "Thief of Thieves" on Saturn's Moon, Titan
      636474187, // Source: Adventure "Deathless" on Saturn's Moon, Titan
      3534706087, // Source: Complete activities and earn rank-up packages on Saturn's Moon, Titan.
    ],
    enteredDCV: 20,
  },
  trials: {
    itemHashes: [
      2307365, // The Inquisitor (Adept)
      711889599, // Whistler's Whim (Adept)
      825554997, // The Inquisitor (Adept)
      1117787139, // Exile's Curse
      1185633760, // The Inquisitor
      1401300690, // Eye of Sol
      1574601402, // Whistler's Whim
      1803480512, // Yesterday's Question
      1940352487, // Tomorrow's Answer
      2059255495, // Eye of Sol (Adept)
      2185327324, // The Inquisitor
      2421180981, // Incisor (Adept)
      2499834164, // Keen Thistle
      2499834165, // Eye of Sol
      2653171212, // The Inquisitor
      2759251821, // Unwavering Duty (Adept)
      2776092652, // Igneous Hammer
      2776092653, // Exalted Truth
      3102421004, // Exalted Truth
      3267997292, // Reed's Regret
      3614211586, // Aisha's Care
      3624844116, // Unwavering Duty
      3747667917, // Shayura's Wrath
      3790632261, // The Scholar
      3920882229, // Exalted Truth (Adept)
      4089030727, // Sola's Scar
      4248997900, // Incisor
      4277548087, // The Messenger
    ],
    sourceHashes: [
      139599745, // Source: Earn seven wins on a single Trials ticket.
      443793689, // Source: Win games on a completed Lighthouse Passage after earning a weekly win streak of five or higher.
      486819617, // Trials of Osiris - WEAPONS
      613791463, // Source: Saint-14 Rank Up Reputation
      752988954, // Source: Flawless Chest in Trials of Osiris
      827839814, // Source: Flawless Chest in Trials of Osiris or Grandmaster Nightfalls
      1218637862, // Source: Open the Lighthouse chest after earning a weekly win streak of five or higher.
      1607607347, // Source: Complete Trials tickets and earn rank-up packages from the Emissary of the Nine.
      1923289424, // Source: Open the Lighthouse chest.
      2857787138, // Source: Trials of Osiris
      3390015730, // Source: Trials of Osiris Challenges
      3471208558, // Source: Trials of Osiris Wins
      3543690049, // Source: Complete a flawless Trials ticket.
      3564069447, // Source: Flawless with a "Flight of the Pigeon" medal for each win
    ],
  },
  umbral: {
    sourceHashes: [
      287889699, // Source: Umbral Engram Tutorial
      1286883820, // Source: Prismatic Recaster
    ],
    enteredDCV: 20,
  },
  vaultofglass: {
    sourceHashes: [
      2065138144, // Source: "Vault of Glass" Raid
    ],
    aliases: ['vog'],
  },
  vespershost: {
    itemHashes: [
      93061497, // VS Gravitic Arrest
      1762785662, // VS Chill Inhibitor
      1762785663, // VS Velocity Baton
      4232480042, // VS Pyroelectric Propellant
    ],
    sourceHashes: [
      2463956052, // Source: Vesper's Host
    ],
    aliases: ['vesper'],
  },
  vexoffensive: {
    itemHashes: [
      351285766, // Substitutional Alloy Greaves
      377757362, // Substitutional Alloy Hood
      509561140, // Substitutional Alloy Gloves
      509561142, // Substitutional Alloy Gloves
      509561143, // Substitutional Alloy Gloves
      695795213, // Substitutional Alloy Helm
      844110491, // Substitutional Alloy Gloves
      1137424312, // Substitutional Alloy Cloak
      1137424314, // Substitutional Alloy Cloak
      1137424315, // Substitutional Alloy Cloak
      1348357884, // Substitutional Alloy Gauntlets
      1584183805, // Substitutional Alloy Cloak
      1721943440, // Substitutional Alloy Boots
      1721943441, // Substitutional Alloy Boots
      1721943442, // Substitutional Alloy Boots
      1855720513, // Substitutional Alloy Vest
      1855720514, // Substitutional Alloy Vest
      1855720515, // Substitutional Alloy Vest
      2096778461, // Substitutional Alloy Strides
      2096778462, // Substitutional Alloy Strides
      2096778463, // Substitutional Alloy Strides
      2468603405, // Substitutional Alloy Plate
      2468603406, // Substitutional Alloy Plate
      2468603407, // Substitutional Alloy Plate
      2657028416, // Substitutional Alloy Vest
      2687273800, // Substitutional Alloy Grips
      2690973101, // Substitutional Alloy Hood
      2690973102, // Substitutional Alloy Hood
      2690973103, // Substitutional Alloy Hood
      2742760292, // Substitutional Alloy Plate
      2761292744, // Substitutional Alloy Bond
      2815379657, // Substitutional Alloy Bond
      2815379658, // Substitutional Alloy Bond
      2815379659, // Substitutional Alloy Bond
      2903026872, // Substitutional Alloy Helm
      2903026873, // Substitutional Alloy Helm
      2903026874, // Substitutional Alloy Helm
      2942269704, // Substitutional Alloy Gauntlets
      2942269705, // Substitutional Alloy Gauntlets
      2942269707, // Substitutional Alloy Gauntlets
      3166926328, // Substitutional Alloy Robes
      3166926330, // Substitutional Alloy Robes
      3166926331, // Substitutional Alloy Robes
      3192738009, // Substitutional Alloy Greaves
      3192738010, // Substitutional Alloy Greaves
      3192738011, // Substitutional Alloy Greaves
      3364258850, // Substitutional Alloy Strides
      3680920565, // Substitutional Alloy Robes
      3757338780, // Substitutional Alloy Mark
      3757338782, // Substitutional Alloy Mark
      3757338783, // Substitutional Alloy Mark
      3911047865, // Substitutional Alloy Mark
      4013678605, // Substitutional Alloy Boots
      4026120124, // Substitutional Alloy Grips
      4026120125, // Substitutional Alloy Grips
      4026120127, // Substitutional Alloy Grips
      4070722289, // Substitutional Alloy Mask
      4078925540, // Substitutional Alloy Mask
      4078925541, // Substitutional Alloy Mask
      4078925542, // Substitutional Alloy Mask
    ],
    sourceHashes: [
      4122810030, // Source: Complete seasonal activities during Season of the Undying.
    ],
    enteredDCV: 20,
  },
  vowofthedisciple: {
    sourceHashes: [
      1007078046, // Source: "Vow of the Disciple" Raid
    ],
    aliases: ['vow', 'votd'],
  },
  warlordsruin: {
    itemHashes: [
      839344841, // Vengeful Whisper
      2806569825, // Naeem's Lance
      3381450498, // Indebted Kindness
      3668817296, // Dragoncult Sickle
    ],
    sourceHashes: [
      613435025, // Source: "Warlord's Ruin" Dungeon
    ],
  },
  wartable: {
    sourceHashes: [
      2653840925, // Source: Challenger's Proving VII Quest
      3818317874, // Source: War Table Reputation Reset
      4079816474, // Source: War Table
    ],
    enteredDCV: 24,
  },
  wellspring: {
    sourceHashes: [
      82267399, // Source: "Warden of the Spring" Triumph
      502279466, // Source: Wellspring Boss Vezuul, Lightflayer
      2917218318, // Source: Wellspring Boss Golmag, Warden of the Spring
      3359853911, // Source: Wellspring Boss Zeerik, Lightflayer
      3411812408, // Source: "All the Spring's Riches" Triumph
      3450213291, // Source: Wellspring Boss Bor'gong, Warden of the Spring
    ],
  },
  wrathborn: {
    itemHashes: [
      197764097, // Wild Hunt Boots
      238284968, // Wild Hunt Strides
      251310542, // Wild Hunt Hood
      317220729, // Wild Hunt Vestment
      1148770067, // Wild Hunt Cloak
      1276513983, // Wild Hunt Gloves
      1458739906, // Wild Hunt Vest
      2025716654, // Wild Hunt Grasps
      2055947316, // Wild Hunt Bond
      2279193565, // Wild Hunt Mark
      2453357042, // Blast Battue
      2545401128, // Wild Hunt Gauntlets
      2776503072, // Royal Chase
      3180809346, // Wild Hunt Greaves
      3351935136, // Wild Hunt Plate
      3887272785, // Wild Hunt Helm
      4079117607, // Wild Hunt Mask
    ],
    sourceHashes: [
      841568343, // Source: "Hunt for the Wrathborn" Quest
      3107094548, // Source: "Coup de Grâce" Mission
    ],
    enteredDCV: 20,
  },
};

export default D2Sources;
